import { useSetAtom } from "jotai";
import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { setSchemaAtom } from "../../../../atoms/GlobalAtoms";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../../utils/GeneralUtils";
import TenantAPI from "../../../api/TenantAPI";
import { newToastEvent } from "../../../../utils/ToastUtil";

// useMutation hook for deleting a modules field
const useDeleteField = () => {
  const setSchema = useSetAtom(setSchemaAtom);
  const queryClient = useQueryClient();
  const [deleteFieldID, setDeleteFieldID] = useState<string | null>(null);

  const deleteField = useMutation({
    mutationFn: ({
      moduleAPIName,
      fieldAPIName,
      supportTargetCloudID,
    }: {
      moduleAPIName: string;
      fieldAPIName: string;
      supportTargetCloudID: string | undefined;
      onSuccess?: () => void;
    }) => {
      setDeleteFieldID(fieldAPIName);
      return TenantAPI.deleteModuleField(
        moduleAPIName,
        fieldAPIName,
        supportTargetCloudID
      );
    },
    onSuccess: (data, { onSuccess, supportTargetCloudID }) => {
      const newSchema = data.data.data.schema;

      if (supportTargetCloudID) {
        queryClient.setQueryData(
          ["cloudSchema", supportTargetCloudID],
          newSchema
        );
      } else {
        setSchema(newSchema);
      }

      callFunctionIfExists(onSuccess, newSchema);
      newToastEvent("success", "Successfully deleted field");
    },
    onError: (error) => {
      newToastEvent(
        "error",
        getErrorMessage(error, "Could not delete field. Please try again.")
      );
    },
    onSettled: () => {
      setDeleteFieldID(null);
    },
  });

  return {
    deleteField: deleteField.mutate,
    deleteFieldID: deleteFieldID ?? undefined,
    deleteFieldError: deleteField.error
      ? getErrorMessage(deleteField.error)
      : null,
  };
};

export default useDeleteField;
